import { DataService } from '@barthauer/abc/core/data';
import { MapStyle } from './models/map.model';

export class MapOsmStyle {
  private stylesData: MapStyle[];
  private stylesCache = {};

  constructor(private coreDataService: DataService) {
    this.coreDataService.getJsonFile('assets/lib-open-layers/map/osm-styles-bright.json').subscribe((_) => {
      this.stylesData = (_ as any).styles.map((_) => _ as MapStyle);
    });
  }

  public findStyles(feature: any, resolution: number): MapStyle[] {
    if (!this.stylesData) {
      try {
        feature.changed();
      } catch {}
      return;
    }
    const ly = feature.get('layer') as string;
    const cls = feature.get('class') as string;
    const subcls = feature.get('subclass') as string;
    const intermittent = this.getBoolClass(feature, 'intermittent');
    const brunnel = feature.get('brunnel') as string;
    const ramp = this.getBoolClass(feature, 'ramp');
    const oneway = this.getBoolClass(feature, 'oneway');
    const key: string = JSON.stringify({
      ly: ly,
      cls: cls,
      subcls: subcls,
      intermittent: intermittent,
      brunnel: brunnel,
      ramp: ramp,
      oneway: oneway,
    });
    let styles = this.stylesCache[key] as MapStyle[];
    if (!styles) {
      styles = MapOsmStyle.findStylesCore(this.stylesData, [ly, cls, subcls, intermittent, brunnel, ramp, oneway]);
      this.stylesCache[key] = styles;
    }

    return styles;
  }

  private getBoolClass(feature: any, name: string): string {
    const cls = feature.get(name) as string;
    if (cls == '1' || cls == 'true') {
      return name;
    } else if (cls == '0' || cls == 'false') {
      return '!' + name;
    } else {
      return cls;
    }
  }

  private static findStylesCore(styles: MapStyle[], values: string[]): MapStyle[] {
    let matchCount = -1;
    let results: MapStyle[] = [];
    let i = 0;
    for (const s of styles) {
      s.zIndex = ++i;
      var partitions = s.partition as string[][];
      if (partitions) {
        for (let i = 0; i < partitions.length; i++) {
          let arr = partitions[i];
          let isMatch = true;
          for (let j = 0; j < arr.length; j++) {
            if (!values.includes(arr[j])) {
              isMatch = false;
              break;
            }
          }
          if (isMatch && arr.length >= matchCount) {
            if (arr.length > matchCount) {
              results = [];
            }
            results.push(s);
            matchCount = arr.length;
          }
        }
      }
    }
    return results;
  }
}
